module.exports = __webpack_public_path__ + "img/会员天地.128b31a7.jpg";